import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { DateRange } from "@mui/x-date-pickers-pro";

import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IOrder, OrderStatus } from "@framework/types";
import { OrderSearchForm } from "@framework/shared";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import type { IPaginationDto, IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { OrderItem } from "./item";
import { parseDateRange, stringifyDateRange } from "./utils";

// @ts-ignore
export type TTransformedSearch = Omit<IOrderSearchDto, "dateRange"> & { dateRange: DateRange<Date> };

export interface IOrderSearchDto extends IPaginationDto {
  orderStatus: Array<OrderStatus>;
  dateRange: string;
}

export const OrderList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = useFetchQuery<
    IPaginationResult<IOrder>
  >("/orders", { enableInfiniteScroll: isMd }, void 0, {
    take: 10,
    orderStatus: [OrderStatus.NEW, OrderStatus.NOW_IN_DELIVERY, OrderStatus.SCHEDULED],
    dateRange: stringifyDateRange(parseDateRange()),
  });

  // const transformSearch = ({ dateRange, ...rest }: IOrderSearchDto): TTransformedSearch => ({
  //   ...rest,
  //   dateRange: parseDateRange(dateRange),
  // });
  //
  // const handleTransformedSearch = (values: TTransformedSearch) => {
  //   const { dateRange, ...rest } = values;
  //
  //   const newSearch: IOrderSearchDto = {
  //     ...rest,
  //     dateRange: stringifyDateRange(dateRange),
  //   };
  //
  //   // return handleSearch(newSearch);
  // };

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "ecommerce", "orders"]} />

      <PageHeader message="pages.orders.title" />

      <OrderSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(order => (
              <OrderItem key={order.id} order={order} />
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
